(function() {

    'use strict';

    /**
     * @module Plugins
     *
     * Looks for functions named onPlay, onClipDone, onReplay, onClickPlay and onClickPause in the parent iframe
     * (the window which instanted the player)
     * and calls the respective methods at the right times if they're available.
     *
     * http://trac.intra.sapo.pt/videosplayer/wiki/InterfaceExterna
     *
     * @namespace sv_external_interface
     */



    var wp = window.parent;

    var onPlay       = wp.onPlay;       // randName
    var onClipDone   = wp.onClipDone;   //
    var onReplay     = wp.onReplay;     // randName
    var onClickPlay  = wp.onClickPlay;  // randName
    var onClickPause = wp.onClickPause; // randName



    var plugin = function(vc) {
        this._vc = vc;

        this._md = undefined;
        this._justStarted = false;

        this._vc.subscribe('ended metadata_changed replay state_changed time_updated', undefined, this);
    };

    plugin.prototype = {

        _name: plugin._name = 'sv_vast',

        on_ended: function() {
            if (onClipDone && this._md) {
                onClipDone(this._md.hash);
            }
            this._justStarted = true;
        },

        on_metadata_changed: function(mt, md) {
            if (!md) { return; }

            this._md = md;

            this._justStarted = true;
        },

        on_replay: function() {
            if (onReplay) {
                onReplay(this._md.hash);
            }
        },

        on_state_changed: function(mt, state) {
            if (this._md) {
                if (state === 'play' && onClickPlay) {
                    onClickPlay(this._md.hash);
                }
                else if (state === 'pause' && onClickPause) {
                    onClickPause(this._md.hash);
                }
            }
        },

        on_time_updated: function(md, t) {
            if (onPlay && this._md && this._justStarted && t > 0) {
                onPlay(this._md.hash);
                this._justStarted = false;
            }
        }

    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);

})(undefined);
